import type { VoidFunctionComponent } from 'react';
import * as _ from 'lodash';
import cx from 'classnames';
import LoadingRow from './ReleaseSelectorRowLoading';
import styles from './ReleaseSelector.module.less';
import type { ProjectGroupRelease } from '../../../../../../shared/model-typings';

type Props = {
  hasNoResults: boolean;
  isLoading: boolean;
  count: number;
  releases: ProjectGroupRelease[];
  selectedReleaseId?: number;
  onReleaseSelect: (releaseId: number) => void;
};

/**
 * ReleaseGroupsReleaseSelectorBody holds the inner list of releases,
 * and determines if we need to render the "no results" or loading UI.
 */
const ReleaseGroupsReleaseSelectorBody: VoidFunctionComponent<Props> = ({
  hasNoResults,
  isLoading,
  count,
  releases,
  selectedReleaseId,
  onReleaseSelect,
}) => {
  if (hasNoResults) {
    return (
      <div className={styles.noResults}>
        No results found
      </div>
    );
  }
  if (isLoading) {
    return _.times(count, () => <LoadingRow />);
  }

  return releases.map((release) => (
    <button
      key={release.id}
      type="button"
      className={cx(styles.release, {
        [styles.selectedRelease]: release.id === selectedReleaseId,
      })}
      title={release.title}
      onClick={() => onReleaseSelect(release.id)}
    >
      {release.title}
    </button>
  ));
};

export default ReleaseGroupsReleaseSelectorBody;
